import { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { useAccountsStore } from '@lib/store';
import { AddItemEnum, type GetAccountsResponse } from '@shared/api';
import { AccountSlideItem, TopUpMyAccountModal } from './widgets';
import { AddNewItemModal, SlideAdd, SlideItem } from '@widgets';
import './accountsSlider.scss';

const settings = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  adaptiveHeight: true,
  cssEase: 'ease-out',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
  ],
};

interface AccountSliderProps {
  animate?: boolean;
  accountsPage?: boolean;
}

export const AccountsSlider = (props: AccountSliderProps) => {
  const accountsStore = useAccountsStore();

  const [slideWidth, setSlideWidth] = useState<number>(440);
  const sliderWrapRef = useRef<HTMLDivElement | null>(null);
  const sliderRef = useRef<any | null>(null);

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [slideAccount, setSlideAccount] = useState<GetAccountsResponse>();
  const [isVisibleAddModal, setIsVisibleAddModal] = useState<boolean>(false);
  const [isVisibleTopModal, setIsVisibleTopModal] = useState<boolean>(false);

  useEffect(() => {
    const updateDimensions = () => {
      if (!sliderWrapRef.current || !sliderRef.current) return;
      const currentSettings = sliderRef.current.innerSlider?.props;
      const currentSlidesToShow = currentSettings.slidesToShow;
      setIsMobile(currentSlidesToShow === 1);
      const sliderWidth = sliderWrapRef.current.clientWidth;
      setSlideWidth(sliderWidth / currentSlidesToShow);
    };
    const timer = setTimeout(updateDimensions, 50);
    window.addEventListener('resize', updateDimensions);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const width = isMobile ? slideWidth : slideWidth + (window.innerWidth > 1024 ? 22 : 14);
  const height = isMobile ? 300 : slideWidth > 350 ? 350 : slideWidth;
  return (
    <div ref={sliderWrapRef} className='-mt-2 mb-10 max-md:pb-5'>
      <Slider ref={sliderRef} className='slider-accounts sliderAnimation' {...settings}>
        {accountsStore.data?.map((account, idx) => {
          return (
            <SlideItem
              key={idx}
              className='h-[350px] w-[440px] cursor-pointer p-5'
              account={account}
              accountsPage={props.accountsPage}
              style={{ width, height }}
            >
              <AccountSlideItem account={account} onSelectAccount={setSlideAccount} onShowTopUpModal={() => setIsVisibleTopModal(true)} />
            </SlideItem>
          );
        })}
        <SlideAdd
          text='Add account'
          className='h-[350px] w-[440px] cursor-pointer p-5 max-md:mb-1.5'
          style={{ width, height }}
          onClick={() => setIsVisibleAddModal(true)}
        />
      </Slider>
      <AddNewItemModal isOpen={isVisibleAddModal} onClose={() => setIsVisibleAddModal(false)} type={AddItemEnum.Account} />
      <TopUpMyAccountModal isOpen={isVisibleTopModal} onClose={() => setIsVisibleTopModal(false)} account={slideAccount} />
    </div>
  );
};
